import { persistCombineReducers, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import base from './base';
import airfareSearch from './airfare-search';
import booking from './booking';
import payment from './payment';

export const config = {
  key: 'root',
  storage,
  timeout: 10000,
  whitelist: [],
};

const airfareSarchPersistConfig = {
  key: 'airfareSearch',
  storage,
  whitelist: [
    'flightTransferDetails',
    'selectedCardsFareTotal',
    'outboundDetails',
  ],
};
const bookingPersistConfig = {
  key: 'booking',
  storage,
  whitelist: ['passengers', 'invoiceData'],
};

const rootReducer = persistCombineReducers(config, {
  base,
  airfareSearch: persistReducer(airfareSarchPersistConfig, airfareSearch),
  booking: persistReducer(bookingPersistConfig, booking),
  payment,
});

export default rootReducer;
